import { Data } from '@angular/router';

export class DsGroupFront {
  /**
   *
   */
  groupsDesc = '';

  /**
   *
   */
  groupsId: number;

  /**
   *
   */
  groupsLabel = '';

  /**
   *
   */
  groupsLevel: number | null = null;

  /**
   *
   */
  guid: number | null = null;

  /**
   *
   */
  roles: number[] = [];

  /**
   *
   */
  users: number[] = [];

  /**
   *Creates an instance of DsGroupFront.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: Data) {
    this.groupsDesc = jsonData.groups_desc || this.groupsDesc;
    this.groupsId = jsonData.groups_id || this.groupsId;
    this.groupsLabel = jsonData.groups_label || this.groupsLabel;
    this.groupsLevel = jsonData.groups_level || this.groupsLevel;
    this.guid = jsonData.guid || this.guid;
    this.roles = jsonData.roles || this.roles;
    this.users = jsonData.users || this.users;
  }
}
